<template>
  <div>
    <com-dialog :visible.sync="visible" width="1200px" title="绑定监控">
      <div>
        <div class="form_item mb-15px">
          <div class="flex items-center mb-15px">
            <div class="label">绑定设备号</div>
            <el-button type="text" @click="addDeviceSn">添加</el-button>
          </div>
          <div class="flex flex-wrap">
            <div
              v-for="(item, index) in form.superviseDeviceBeanList"
              :key="index"
              class="mb-15px relative price_wrapper flex flex-col justify-center w-500px mr-20px"
            >
              <div>
                <div class="flex flex-wrap items-center">
                  <div class="mb-10px mr-15px plr-5px ptb-5px combo_wrapper relative">
                    <div class="flex items-center mtb-10px">
                      <div class="label">设备号</div>
                      <el-input
                        placeholder="请输入"
                        v-model="item.sn"
                        class="w-180px"
                      > </el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="remove" @click="form.superviseDeviceBeanList.splice(index, 1)">
                <i class="el-icon-remove"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end mt-15px">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { bandMonitorDevices } from '@/api/minitor'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      visible: false,
      type: '',
      form: {
        superviseDeviceBeanList: []
      }
    }
  },
  methods: {
    open(opt) {
      this.form.refStore = opt.refStore
      this.visible = true
    },
    close() {
      this.visible = false
      setTimeout(() => {
        this.form = {}
      }, 200)
    },
    confirm() {
      if (!this.form.superviseDeviceBeanList.length) return this.$message.warning('设备号不能为空')
      bandMonitorDevices(this.form).then(() => {
        this.$emit('update')
        this.$message.success('操作成功')
        this.close()
      })
    },
    addDeviceSn() {
      const params = {
        sn: ''
      }
      this.form.superviseDeviceBeanList.push(params)
      this.$forceUpdate()
    },
  }
}
</script>

<style lang="scss" scoped>
.form_item {
  .label {
    width: 80px;
  }
  .input {
    .el-input__inner {
      width: 300px !important;
    }
  }

  .price_wrapper {
    border: solid 1px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    padding-left: 16px;
    .remove {
      position: absolute;
      top: -10px;
      right: -10px;
      cursor: pointer;
    }
  }
}
</style>
